import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polyline, Marker, Popup, useMap, ZoomControl } from 'react-leaflet';
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase"; 
import L from 'leaflet';
import gpxParser from 'gpxparser';
import 'leaflet/dist/leaflet.css';
import Colaboradores from './Colaboradores';
import Temporizador from '../components/Temporizador'

// --- CONFIGURACIÓN DEL ICONO DE BICICLETA ---
const bikeIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/3714/3714324.png',
  iconRetinaUrl: 'https://cdn-icons-png.flaticon.com/512/3714/3714324.png',
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  shadowSize: [41, 41],
  shadowAnchor: [12, 41]
});

// 🔍 VALORES DE PRUEBA PARA EL ZOOM GLOBAL
// Prueba con 5 (Muy lejano, verás España y Francia enteras)
// Prueba con 6 o 7 (Equilibrado: se aprecia perfectamente la mitad norte de España y el sur de Francia)
const ZOOM_GLOBAL = 6; 

function LMapResizer() {
  const map = useMap();
  useEffect(() => {
    setTimeout(() => { map.invalidateSize(); }, 200);
  }, [map]);
  return null;
}

// 🔥 CONTROLADOR DE CENTRADO CON ZOOM REAJUSTADO
function MapCentering({ livePos }) {
  const map = useMap();
  const [hasCentered, setHasCentered] = useState(false);

  useEffect(() => {
    if (livePos) {
      if (!hasCentered) {
        // Al cargar la señal por primera vez, forzamos la vista amplia panorámica
        map.setView(livePos, ZOOM_GLOBAL);
        setHasCentered(true);
      } else {
        // Al moverse en ruta, la cámara se desplaza de forma sutil sin alterar el 
        // zoom lejano que el usuario tenga o hayamos configurado por defecto.
        map.panTo(livePos);
      }
    }
  }, [livePos, map, hasCentered]);

  return null;
}

const SigueElReto = () => {
  const [positions, setPositions] = useState([]);
  const [livePos, setLivePos] = useState(null);
  const [kmRestantes, setKmRestantes] = useState(null);
  const [porcentaje, setPorcentaje] = useState(0);

  useEffect(() => {
    fetch('/ruta.gpx')
      .then(res => res.text())
      .then(xml => {
        try {
          const gpx = new gpxParser();
          gpx.parse(xml);
          if (gpx.tracks && gpx.tracks.length > 0) {
            const coords = gpx.tracks[0].points.map(p => [p.lat, p.lon]);
            setPositions(coords);
          }
        } catch (err) { console.error("Error GPX", err); }
      });
  }, []);

  useEffect(() => {
    if (positions.length === 0) return;
    const unsub = onSnapshot(doc(db, "seguimiento", "francisco"), (docSnap) => {
      if (!docSnap.exists()) {
        setLivePos(null);
        setKmRestantes(null);
        return;
      }
      const data = docSnap.data();
      const actual = [data.lat, data.lng];
      setLivePos(actual);

      let indiceCercano = 0;
      let minDistancia = Infinity;
      positions.forEach((p, index) => {
        const d = L.latLng(actual).distanceTo(L.latLng(p));
        if (d < minDistancia) {
          minDistancia = d;
          indiceCercano = index;
        }
      });

      let metrosQueFaltan = 0;
      for (let i = indiceCercano; i < positions.length - 1; i++) {
        metrosQueFaltan += L.latLng(positions[i]).distanceTo(L.latLng(positions[i + 1]));
      }

      setKmRestantes((metrosQueFaltan / 1000).toFixed(1));
      setPorcentaje(((indiceCercano / (positions.length - 1)) * 100).toFixed(1));
    });
    return () => unsub();
  }, [positions]);

  if (positions.length === 0) return null;

  const centroInicial = livePos ? livePos : positions[0];

  return (
    <div style={{ width: '100%', maxWidth: '900px', margin: '40px auto', padding: '0 20px', boxSizing: 'border-box' }}>
      
      {/* --- TÍTULO Y ENCABEZADO --- */}
      <div style={{ textAlign: 'center', marginBottom: '30px', marginTop: '40px' }}>
        <div style={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          gap: '8px', 
          backgroundColor: '#ffeef4', 
          padding: '6px 12px', 
          borderRadius: '50px',
          marginBottom: '15px'
        }}>
          <span className="live-dot"></span>
          <span style={{ fontSize: '12px', fontWeight: '800', color: '#ff0055', letterSpacing: '1px' }}>EN VIVO</span>
        </div>
        
        <h1 style={{ 
          margin: 0, 
          fontSize: 'clamp(24px, 5vw, 36px)', 
          fontWeight: '900', 
          color: '#3b203b',
          lineHeight: '1.2'
        }}>
          Sigue la ubicación de <span style={{ color: '#e57be3' }}>Francisco</span> en directo
        </h1>
        <p style={{ color: '#888', marginTop: '10px', fontSize: '16px' }}>
          Acompaña a Francisco Correoso en cada kilómetro de este desafío.
        </p>
      </div>

      {/* --- CONTENEDOR DEL MAPA --- */}
      <div style={{
        height: '550px', 
        width: '100%', 
        position: 'relative', 
        borderRadius: '30px', 
        overflow: 'hidden',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
        border: '8px solid white',
      }}>
        
        {/* WIDGET CENTRADO */}
        {livePos && kmRestantes !== null && (
          <div style={{
            position: 'absolute', top: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: 1000,
            backgroundColor: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(8px)',
            padding: '15px 20px', borderRadius: '20px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
            width: '85%', maxWidth: '320px', textAlign: 'center',
            border: '1px solid rgba(229, 123, 227, 0.2)'
          }}>
            <h4 style={{ margin: 0, fontSize: '9px', color: '#888', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
              Progreso del Reto
            </h4>
            
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', gap: '5px', margin: '8px 0' }}>
              <span style={{ fontSize: '32px', fontWeight: '900', color: '#3b203b' }}>{kmRestantes}</span>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#3b203b', opacity: 0.7 }}>km para la meta</span>
            </div>

            <div style={{ width: '100%', background: '#f0f0f0', height: '8px', borderRadius: '10px', overflow: 'hidden' }}>
              <div style={{ 
                width: `${porcentaje}%`, 
                background: 'linear-gradient(90deg, #e57be3, #3b203b)', 
                height: '100%', 
                transition: 'width 1s ease-in-out' 
              }}></div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#e57be3' }}>{porcentaje}% completado</span>
                <span style={{ fontSize: '11px', color: '#aaa' }}>{positions.length > 0 ? "Destino: Higueruela" : ""}</span>
            </div>
          </div>
        )}

        <MapContainer 
          center={centroInicial} 
          zoom={ZOOM_GLOBAL} /* 🔥 Aplicamos el zoom amplio en la carga inicial estática */
          zoomControl={false}
          style={{ height: '100%', width: '100%' }}
        >
          <LMapResizer />
          <MapCentering livePos={livePos} />
          
          <ZoomControl position="bottomright" />
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Polyline positions={positions} pathOptions={{ color: '#e57be3', weight: 6, opacity: 0.6 }} />
          
          {livePos && (
            <Marker position={livePos} icon={bikeIcon}>
              <Popup>
                <strong>Francisco Correoso</strong><br />
                Pedaleando ahora mismo.
              </Popup>
            </Marker>
          )}
        </MapContainer>
      </div>

      <style jsx>{`
        .live-dot {
          width: 8px;
          height: 8px;
          background-color: #ff0055;
          border-radius: 50%;
          position: relative;
        }
        .live-dot::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: #ff0055;
          border-radius: 50%;
          animation: live-pulse 1.5s infinite;
        }
        @keyframes live-pulse {
          0% { transform: scale(1); opacity: 0.8; }
          100% { transform: scale(3); opacity: 0; }
        }
      `}</style>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '60px', textAlign: 'center' }}>
      </div>
      <Temporizador/>
    </div>
  );
};

export default SigueElReto;